import { RootState } from '@Common/models/redux/store';
import { useSelector } from 'react-redux';
import German from 'public/i18n/de.json';

export const useTranslate = () => {
  const language = useSelector((state: RootState) => state.grmr.controls.gcLanguage);

  const translate = (text: string) => {
    let translatedText = null;
    if (language === 'DE') translatedText = (German as any)[text];
    if (translatedText) return translatedText;
    return text;
  };

  return { translate };
};
